<template>
  <div class="container">
    <div class="container-header">
      <van-nav-bar title="人员选择" safe-area-inset-top :border="false">
        <template #left>
          <img @click="handleBack" style="width: 24px; height: 24px" src="@/assets/back.png" />
        </template>
      </van-nav-bar>

      <div class="search">
        <van-search v-model="searchValue" @search="onSearch" show-action placeholder="请输入人员名搜索">
          <template #action>
            <div @click="onSearch">搜索</div>
          </template>
        </van-search>
      </div>
    </div>

    <div class="list">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <van-cell v-for="(item, index) in list" :key="index" class="item">
            <div class="item_line1">
              <van-checkbox v-model="item.isChecked" @change="changeCheckBox(item)" shape="square"></van-checkbox>
              <div class="item_title">
                <img v-if="item.avatar" :src="item.avatar" />
                <img v-else src="@/assets/default.png" />
                <div>
                  <div>{{ item.name }}</div>
                  <div>{{ item.phone }}</div>
                </div>
              </div>
            </div>
            <div class="item_line2">
              <div>
                <span>公司名称：</span>
                <span>{{ item.companyName }}</span>
              </div>
              <div>
                <span>部门名称：</span>
                <span>{{ item.officeName }}</span>
              </div>
              <div>
                <span>岗位：</span>
                <span>{{ item.post }}</span>
              </div>
            </div>
          </van-cell>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { getClassificationStatistics } from '@/axios/services';
import { Toast } from 'vant';
export default {
  data() {
    return {
      searchValue: '',
      loading: false,
      finished: false,
      refreshing: false,
      currentPage: 1,
      currentPageSize: 10,
      list: []
    };
  },
  computed: {
    ...mapState(['initialData', 'selectedList', 'status'])
  },
  methods: {
    ...mapMutations(['setSelectList']),
    handleBack() {
      window.history.go(-1);
    },
    onSearch() {
      this.currentPage = 1;
      this.list = [];
      this.onLoad();
    },
    changeCheckBox(item) {
      this.setSelectList(item);
      this.$forceUpdate();
      this.$parent.$forceUpdate();
    },
    onLoad() {
      this.getClassificationStatistics();
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.currentPage = 1;
      this.onLoad();
    },
    getClassificationStatistics() {
      const params = {
        companyId: this.initialData.companyId,
        currentPageSize: this.currentPageSize,
        jobStatus: 0,
        operationalPermissions: 1,
        searchType: 2,
        activeState: 0,
        allShowView: 0,
        searchKey: this.searchValue,
        currentPage: this.currentPage
      };
      getClassificationStatistics(params).then(res => {
        if (res.data.code === 0) {
          this.currentPage++;
          this.loading = false;

          if (res.data.data) {
            let { records, total } = res.data.data;
            records.forEach(item => {
              if (this.selectedList[`${this.status}`]) {
                this.selectedList[`${this.status}`].forEach(i => {
                  if (item.id && item.id === i.id) {
                    item.isChecked = true;
                  }
                });
              }
              item.staffName = item.name;
              item.staffId = item.id;
            });
            console.log(records);
            if (this.refreshing) {
              this.list = [];
              this.refreshing = false;
            }
            if (this.list.length === 0) {
              this.list = records;
            } else {
              this.list = this.list.concat(records);
            }
            if (this.list.length >= total) {
              this.finished = true;
            } else {
              this.finished = false;
            }
          }
        } else {
          Toast.fail(res.data.msg);
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  height: 100vh;
  display: flex;
  flex-direction: column;
  padding-bottom: 68px;

  .list {
    width: 343px;
    margin: 16px auto;
    flex: 1;
    overflow-y: auto;
    .item {
      width: 343px;
      height: 162px;
      background-color: #ffffff;
      border-radius: 4px;
      margin-bottom: 16px;
      padding: 16px;
      .item_line1 {
        display: flex;
        border-bottom: 1px solid #f3f3f3;
        padding-bottom: 15px;
        .item_title {
          display: flex;
          align-items: center;
          margin-left: 16px;
          img {
            width: 40px;
            height: 40px;
            margin-right: 10px;
          }
          div {
            font-family: Source Han Sans CN;
            color: #333333;
            font-size: 14px;
          }
        }
        .item_line2 {
          font-family: Source Han Sans CN;
          color: #666666;
          font-size: 14px;
        }
      }
    }
  }

  .search {
    width: 100%;
    background-color: #ffffff;
  }
}
</style>
